"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[722,998],{

/***/ 998:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ cart)
});

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(692);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
;// ./node_modules/@on-sight-strategy/os-utilities/src/functions.js
/**
 * * Checks if the given elements exist on the DOM
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */
function elementsExist(elements = []) {
  return elements.filter((el) => el.length).length == elements.length
}

/**
 * * Applies scroll locked styles to the docuemnt body
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */
function toggleScroll({ lock, yPosition }) {
  const body = document.body

  // Check if the scroll should be locked or unlocked
  const lockScroll = lock != null ? lock == true : body.style.overflow != 'hidden'

  if (lockScroll) {
    // Lock the scroll
    let scrollPosition = window.pageYOffset
    if (yPosition != null) scrollPosition = yPosition

    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.top = `-${scrollPosition}px`
    body.style.width = '100%'
  } else {
    // Unlock the scroll
    const scrollPosition = parseInt(body.style.top) * -1

    body.style.removeProperty('overflow')
    body.style.removeProperty('position')
    body.style.removeProperty('top')
    body.style.removeProperty('width')

    window.scrollTo({ top: scrollPosition, behavior: 'instant' })
  }
}

/**
 * * Determines if the current screen is mobile-sized
 *
 * @returns {boolean} Whether the current screen width is within the mobile threshhold
 */
function isMobile() {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    return true
  }

  return false
}


/**
 * Listens for user interaction to determine if user is navigating by keyboard 
 * (used in tandem with [data-tab-nav='true'] CSS Selector to allow different ::focus-visible configurations for Mouse-Nav vs Tab-Nav)
 * 
 * @param {Object} event - The event object
 * 
 * @example
 * $(document).on('keydown', function(e) {
 *  currentUserNavigationMethod(e);
 * })
 * 
 * input:focus-visible{
 *  box-shadow: 0 0 0 1px theme('colors.primary');
 * }
 * [data-tab-nav='true'] input:focus-visible {
 *  box-shadow: 0 0 0 3px theme('colors.secondary'), 0 0 3px 6px theme('colors.primary');
 * }
 * 
 */
function currentUserNavigationMethod(event) {
  const body = document.body
  // Default behavior is mouse

  if (event.key === "Tab") {
    if (body.dataset.tabNav !== 'true') {
      body.dataset.tabNav = 'true'

      document.addEventListener('click', () => {
        body.dataset.tabNav = 'false'
      }, { once: true })
    }
  }
}


/**
 *
 * @param {*} cents
 * @param {*} format
 * @returns
 */
function formatMoney(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '')

  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || '${{ amount_no_decimals }}'

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

/**
 * Updates a list of elements to all match the height of the tallest element provided
 *
 * @param {jQuery node list} $elements
 */
function syncElementsHeight($elements) {
  if (!$elements.length) return

  // Reset heights to get accurate measurement
  $elements.height('auto')

  // Sort elements by intrinsic height
  const sortedByHeight = $elements.sort((a, b) => {
    return b.offsetHeight - a.offsetHeight
  })
  const maxHeight = sortedByHeight[0].offsetHeight

  // Set all elements to match the tallest element found
  $elements.height(maxHeight)
}

// Get the number of pixels an element is on screen
function calculatePixelsOnScreen(element) {
  // Make sure we have a jQuery object

  if (!element instanceof HTMLElement) return;

  // Get the element height, top, and bottom
  const top = element.offsetTop;
  const height = element.offsetHeight;
  const elementBottom = top + height;

  // Get the viewport top and bottom
  const viewportTop = window.scrollY
  const viewportBottom = viewportTop + window.innerHeight

  // Calculate the number of pixels above and below the screen
  const pixelsAboveScreen = Math.max(viewportTop - top, 0)
  const pixelsBelowScreen = Math.max(elementBottom - viewportBottom, 0)
  const pixelsRemaining = Math.max(height - pixelsAboveScreen - pixelsBelowScreen, 0)

  // Return the remaining number of pixels on screen
  return pixelsRemaining;
}

// Get the element that is taking up the most visible space on screen
function getElementMostVisible($elements) {
  const elementsArray = $elements.toArray()

  const elementMostVisible = elementsArray.reduce((elementA, elementB) => {
    // Compare the number of pixels on screen for each element in the array
    const pixelsOnScreenA = calculatePixelsOnScreen(elementA)
    const pixelsOnScreenB = calculatePixelsOnScreen(elementB)

    // Return the element with the most pixels on screen
    if (pixelsOnScreenB > pixelsOnScreenA) return elementB
    return elementA
  }, $elements[0])

  return elementMostVisible
}

function debounce(callback, wait = 200) {
  let timeoutId = null

  return (...args) => {
    window.clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      callback.apply(this, args)
    }, wait)
  }
}
// EXTERNAL MODULE: ./dev/js/snippets/greenspark-cart-widget.js
var greenspark_cart_widget = __webpack_require__(341);
;// ./dev/js/components/global/slide-cart.js




function cart({ wrapper }) {
  const sectionID = jquery_default()(wrapper).data('section-id')

  // TailwindCSS variants representing different states
  const { classes } = window.config

  const urls = {
    update: '/cart/update.js',
    change: '/cart/change.js',
    add: '/cart/add.js',
    get: '/cart.json',
  }

  const selectors = {
    addByID: '[data-hook="addProductByID"]',
    cartItem: '[data-hook="cart-item"]',
    cartNote: '[data-hook="cart-note"]',
    closeCart: '[data-hook="close-cart"]',
    productForm: 'form[action="/cart/add"]',
    removeItem: '[data-hook="remove-item"]',
    toggleCart: '[data-hook="toggle-cart"]',
    upgradeToSubscriptionBtn: '[data-hook="upgrade-to-sub"]',
    updateSellingPlan: '[data-hook="update-selling-plan"]',
    quantityInput: '[data-hook="quantity"]',
    cartInner: '[data-cart-section="inner"]',
    overlay: '[data-hook="overlay"]',
    cartCount: '[data-hook="cart-count"]',
  }

  let state = {
    focusOnClose: null,
  }

    ; (function init() {
      render()

      // Automatically opens cart on redirect from '/cart' if '?open_cart' is present in the URL
      if (new URL(location).searchParams.has('open_cart')) open()

      initOutsideEventListeners()
      initInsideEventListeners()
    })()

  function initOutsideEventListeners() {
    jquery_default()(document).on('click', selectors.addByID, addProductByID)
    jquery_default()(document).on('cart:addProductByID', onAddProductByID)
    jquery_default()(document).on('submit', selectors.productForm, onProductSubmit)
    jquery_default()(document).on('cart:open', open)
    jquery_default()(document).on('cart:close', close)
    jquery_default()(document).on('cart:toggle', toggle)
    jquery_default()(document).on('cart:render', render)
    jquery_default()(document).on('popup:close', close)
    jquery_default()(document)
      .off('click', selectors.toggleCart)
      .on('click', selectors.toggleCart, (event) => {
        state.focusOnClose = jquery_default()(event.target)
        jquery_default()(document).trigger('cart:toggle')
      })
  }

  function initInsideEventListeners() {
    jquery_default()(wrapper).on('click', selectors.closeCart, () => jquery_default()(wrapper).trigger('cart:close'))
    jquery_default()(wrapper).on('click', selectors.removeItem, removeFromCart)
    jquery_default()(wrapper).on('click', selectors.upgradeToSubscriptionBtn, updateSubscription)
    jquery_default()(wrapper).on('change', selectors.updateSellingPlan, updateSubscription)
    jquery_default()(wrapper).on('quantity-box:change', selectors.quantityInput, debounce(changeItemQuantity))
    jquery_default()(wrapper).on('change', selectors.cartNote, updateCartNote)
  }

  // Example of how to add a product to the cart without a form
  function addProductByID(event) {
    const id = jquery_default()(this).data('variant-id')

    // Uses a custom event so we can trigger this from anywhere
    jquery_default()(document).trigger('cart:addProductByID', { trigger: this, id, quantity: 1 })
  }

  // Handle the event when a product is added to the cart by ID
  function onAddProductByID(event, { trigger, id, quantity }) {
    addToCart({ id, quantity }, trigger)
  }

  // Handle the submission of a product form
  function onProductSubmit(e) {
    e.preventDefault()

    const $form = jquery_default()(this)

    const data = $form.serialize()

    addToCart(data, this)
  }

  // Add a product to the cart
  function addToCart(data, trigger) {
    // Update which element we should focus on when the cart closes
    state.focusOnClose = jquery_default()(trigger)

    jquery_default()(trigger).addClass(classes.loading)

    processCartRequest({
      data,
      url: urls.add,
      success: function () {
        // Build cart
        render()

        // Open cart
        jquery_default()(document).trigger('cart:open')

        jquery_default()(trigger).removeClass(classes.loading)
      },
      error: function () {
        jquery_default()(trigger).removeClass(classes.loading).addClass(classes.error)
      },
    })
  }

  // Remove an item from the cart
  function removeFromCart() {
    const $item = jquery_default()(this).closest(selectors.cartItem)
    let key = $item.data('key')

    let data = {
      updates: {
        [key]: 0,
      },
    }

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    processCartRequest({
      data,
      url: urls.update,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  // Handle the change in quantity for an item
  function changeItemQuantity(event) {
    const $item = jquery_default()(event.target).closest(selectors.cartItem)
    let key = $item.data('key')

    let data = {
      updates: {
        [key]: jquery_default()(event.target).val(),
      },
    }

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    processCartRequest({
      data,
      url: urls.update,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  // Update the item subscription / selling_plan
  function updateSubscription(event) {
    event.preventDefault()

    const $trigger = jquery_default()(this)
    const $item = $trigger.closest(selectors.cartItem)
    let { key, quantity, sellingPlan } = $trigger.data()

    if ($trigger.val()) {
      sellingPlan = $trigger.val()
    }

    const data = {
      quantity: quantity,
      id: key,
      selling_plan: sellingPlan === 'onetime' ? '' : sellingPlan,
    }

    processCartRequest({
      data,
      url: urls.change,
      success: function () {
        render()

        $item.removeClass(classes.loading)
      },
    })
  }

  function getCart(callback) {
    processCartRequest({
      data: null,
      url: urls.get,
      success: callback,
    })
  }

  // Toggle the cart open/close state
  function toggle() {
    if (jquery_default()(wrapper).hasClass(classes.active)) {
      close()
    } else {
      open()
    }
  }

  // Open the cart
  function open() {
    jquery_default()(wrapper).addClass(classes.active)

    jquery_default()(document).trigger('overlay:show')

    // Lock scrolling outside the cart
    toggleScroll({ lock: true })

    // Restrict tabbing outside of the cart
    // restrictTabbing()
  }

  // Close the cart
  function close() {
    jquery_default()(wrapper).removeClass(classes.active)

    // Remove overlay
    jquery_default()(document).trigger('overlay:hide')

    // Unock scrolling outside the cart
    toggleScroll({ lock: false })

    // Unrestrict tabbing outside of the cart
    // allowTabbing()

    // Return focus to the element that triggered the cart to open
    state.focusOnClose && state.focusOnClose.trigger('focus')
  }

  // Update the cart note
  function updateCartNote(event) {
    const $note = jquery_default()(this)

    const data = {
      note: $note.val(),
    }

    processCartRequest({ data, url: urls.update, success: null })
  }

  // Restrict tabbing outside the cart
  function restrictTabbing() {
    const $inertElements = jquery_default()(wrapper).parent().siblings().not(selectors.overlay)
    $inertElements.attr('inert', true)
  }

  // Allow tabbing outside the cart
  function allowTabbing() {
    const $inertElements = jquery_default()(wrapper).parent().siblings().not(selectors.overlay)
    $inertElements.removeAttr('inert')
  }

  function updateCartCount() {
    getCart(function (cart) {
      jquery_default()(selectors.cartCount).text(cart.item_count)
      jquery_default()(selectors.cartCount).toggleClass(classes.active, !!cart.item_count)
    })
  }



  // Render the cart
  function render() {
    updateCartCount()

    console.log('render function firing!!!')

    jquery_default().ajax(`/?sections=${sectionID}`).then(function (response) {
      if (response[sectionID]) {
        const $cartInner = jquery_default()(wrapper).find(selectors.cartInner)
        const $newCartInner = jquery_default()(response[sectionID]).find(selectors.cartInner)

        $cartInner.replaceWith($newCartInner)

        // Add Greenspark widget
        const isMobileDevice = isMobile()
        if (!isMobileDevice) {
          (0,greenspark_cart_widget.renderGreensparkWidget)()
        }
      }
    })


  }

  // Process a cart request
  function processCartRequest({ data, url, success = render, error }) {
    let params = {
      url,
      data,
      method: 'POST',
      dataType: 'json',
      success,
      error: function (err) {
        console.warn(err)

        if (error) error()
      },
    }

    jquery_default().ajax(params)
  }
}


/***/ }),

/***/ 341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   renderGreensparkWidget: () => (/* binding */ renderGreensparkWidget)
/* harmony export */ });
// add Greenspark widget whenever the cart is rendered [rc]
async function renderGreensparkWidget() {
  const fetchResponse = await fetchWidgetHtml() || null;
  const parser = new DOMParser();
  const html = fetchResponse ? parser.parseFromString(fetchResponse, 'text/html') : null;
  const widgetHTML = html ? html.body.firstChild : null;
  const greensparkWrapper = document.getElementById('greenspark-cart-widget');

  if (greensparkWrapper && html && widgetHTML) {
    greensparkWrapper.appendChild(widgetHTML);
  }
}

async function fetchWidgetHtml() {
  const publicApiKey = "ol%2FEY06ec%2F0RkDzuN5rYthpxoZR7EAdJp0ol7rN5nwBveWxCbo3wY%2Fo3Vxw0XcvVPN3WuosNZq";
  const cartElement = document.getElementById("greenspark-cart-data");
  const cart = cartElement && cartElement.textContent ? JSON.parse(cartElement.textContent) : null;

  const lineItems = cart ? cart.items.map(item => ({
    productId: item.product_id,
    quantity: item.quantity
  })) : null;

  const cartTotal = cart ? cart.total_price : 0;

  let options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      'x-api-key': publicApiKey
    },
    body: JSON.stringify({
      shopUniqueName: 'pop-bottle.myshopify.com',
      color: 'black',
      order: {
        currency: 'USD',
        totalPrice: cartTotal,
        lineItems: lineItems
      },
      withPopup: false
    })
  };

  if (cartTotal > 0) {
    try {
      const response = await fetch('https://api.getgreenspark.com/widgets/cart-widget?lng=en', options);
      if (!response.ok) throw new Error('Network response was not ok');
      const responseText = await response.text();
      return responseText;
    } catch (error) {
      console.log("Unable to add Greenspark total. Error: ", error);
      return;
    }
  }
}


/***/ })

}]);